import { defineAction } from '~/prix'
import { z } from 'zod'
import collectedAnimalListAction from './collectedAnimalList.action.json' with { type: 'json' }
import { collectedAnimalObject } from '../collectedAnimalObject'
import { enumerated } from '~/prix/types/enumerated'

const collectedAnimalListDefinition = defineAction({
  ...collectedAnimalListAction,

  input: z.object({
    incentiveId: z.string().uuid().nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      id: 'Identificador',
      earringNumber: 'Brinco',
    }).nullish(),
    order: enumerated({ ascending: 'Ascendente', descending: 'Descendente' }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(collectedAnimalObject), count: z.number() }),
})

export default collectedAnimalListDefinition
